import React from "react";
import { TableRow, TableCell, Chip, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import GenricButton from "../Custom/GenericButton";
import { getStatusColor } from "../../globals/utils";

const OrderDesktopCard = ({ order, onViewDetails, customButtons }) => {
  const { t } = useTranslation();

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell>
        {order.order_type === "FARMER"
          ? order.farmer_name
          : order.institution_name}
      </TableCell>
      <TableCell>{order.id}</TableCell>
      <TableCell>{`${order.requested_quantity} kg`}</TableCell>
      <TableCell>{`Rs. ${order.total_amount_payable}`}</TableCell>
      <TableCell>
        <Chip
          label={order.order_status}
          color={getStatusColor(order.order_status)}
          size="small"
        />
      </TableCell>
      <TableCell>
        <Box sx={{ display: "flex", gap: 1 }}>
          {customButtons && (
            <>
              {customButtons.map((button, index) => (
                <GenricButton
                  key={index}
                  backgroundColor={
                    button.color === "primary"
                      ? "primary"
                      : button.color === "info"
                      ? "#2196f3"
                      : "#F7A419"
                  }
                  fontColor="#fff"
                  fontSize="12px"
                  padding="5px 10px"
                  onClick={button.onClick}
                  disabled={button.disabled}
                >
                  {t(button.label)}
                </GenricButton>
              ))}
            </>
          )}
          <GenricButton
            backgroundColor="primary"
            fontColor="#fff"
            fontSize="12px"
            padding="5px 10px"
            onClick={() => onViewDetails(order)}
          >
            {t("Full Details")}
          </GenricButton>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default OrderDesktopCard;
